import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type HistoryProps = IconComponentBaseProps;

export const History = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: HistoryProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7331_560"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7331_560)">
        <path
          d="M11.9808 20.5C9.97061 20.5 8.19886 19.8865 6.66553 18.6595C5.13219 17.4327 4.14944 15.8628 3.71728 13.95C3.66344 13.7513 3.69586 13.5687 3.81453 13.402C3.93303 13.2353 4.10094 13.1385 4.31828 13.1115C4.52278 13.0847 4.70611 13.1251 4.86828 13.2327C5.03044 13.3404 5.14361 13.4988 5.20778 13.7078C5.58844 15.2526 6.40861 16.5208 7.66828 17.5125C8.92795 18.5042 10.3654 19 11.9808 19C13.9308 19 15.5849 18.3208 16.9433 16.9625C18.3016 15.6042 18.9808 13.95 18.9808 12C18.9808 10.05 18.3016 8.39583 16.9433 7.0375C15.5849 5.67917 13.9308 5 11.9808 5C10.8884 5 9.86478 5.24267 8.90978 5.728C7.95461 6.21317 7.13211 6.88075 6.44228 7.73075H8.30778C8.52028 7.73075 8.69836 7.80267 8.84203 7.9465C8.98586 8.09033 9.05778 8.2685 9.05778 8.481C9.05778 8.69367 8.98586 8.87175 8.84203 9.01525C8.69836 9.15892 8.52028 9.23075 8.30778 9.23075H4.88478C4.62861 9.23075 4.41394 9.14408 4.24078 8.97075C4.06744 8.79758 3.98078 8.58292 3.98078 8.32675V4.90375C3.98078 4.69125 4.05269 4.51317 4.19653 4.3695C4.34036 4.22567 4.51861 4.15375 4.73128 4.15375C4.94378 4.15375 5.12186 4.22567 5.26553 4.3695C5.40903 4.51317 5.48078 4.69125 5.48078 4.90375V6.523C6.29228 5.56533 7.26411 4.82208 8.39628 4.29325C9.52828 3.76442 10.7231 3.5 11.9808 3.5C13.1608 3.5 14.266 3.72308 15.2965 4.16925C16.327 4.61542 17.2256 5.22183 17.9923 5.9885C18.7589 6.75517 19.3654 7.65367 19.8115 8.684C20.2577 9.7145 20.4808 10.8197 20.4808 11.9995C20.4808 13.1793 20.2577 14.2846 19.8115 15.3152C19.3654 16.3461 18.7589 17.2448 17.9923 18.0115C17.2256 18.7782 16.327 19.3846 15.2965 19.8307C14.266 20.2769 13.1608 20.5 11.9808 20.5ZM12.7595 11.6962L15.5095 14.4462C15.648 14.5846 15.7189 14.7586 15.722 14.9683C15.7254 15.1779 15.6545 15.3552 15.5095 15.5C15.3647 15.6448 15.1891 15.7172 14.9828 15.7172C14.7763 15.7172 14.6006 15.6448 14.4558 15.5L11.5308 12.575C11.4373 12.4813 11.3687 12.3793 11.325 12.269C11.2815 12.1587 11.2598 12.0447 11.2598 11.927V7.75C11.2598 7.5375 11.3316 7.35933 11.4753 7.2155C11.6191 7.07183 11.7974 7 12.01 7C12.2225 7 12.4006 7.07183 12.5443 7.2155C12.6878 7.35933 12.7595 7.5375 12.7595 7.75V11.6962Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
